import constantFactory from "@gaoding/constant-factory";
import dayjs from "dayjs";
//加减一天的原因是因为，20230925 相当于到20230925 的0点
const today = dayjs().add(1, "day").format("YYYYMMDD");
const before7Days = dayjs().subtract(6, "day").format("YYYYMMDD");
const before30Days = dayjs().subtract(29, "day").format("YYYYMMDD");
const before3Month = dayjs().subtract(3, "month").format("YYYYMMDD");
const before6Month = dayjs().subtract(6, "month").format("YYYYMMDD");
const before12Month = dayjs().subtract(12, "month").format("YYYYMMDD");

export const { TIME, TIME_LIST, TIME_MAP, TIME_ITEM_MAP } = constantFactory(
  "TIME",
  [
    {
      key: "0",
      label: "近7日",
      value: `${before7Days}-${today}`,
    },
    {
      key: "1",
      label: "近30天",
      value: `${before30Days}-${today}`,
    },
    {
      key: "2",
      label: "近1-3个月",
      value: `${before3Month}-${before30Days}`,
    },
    {
      key: "3",
      label: "近3-6个月",
      value: `${before6Month}-${before3Month}`,
    },
    {
      key: "4",
      label: "近6-12个月",
      value: `${before12Month}-${before6Month}`,
    },
    {
      key: "5",
      label: "1年以上",
      value: `-${before12Month}`,
    },
  ]
);
